import type { AgentTool } from '@saaga/shared/interfaces/agent-tool.interface'
import type { LlmModel } from '@saaga/shared/interfaces/llm-model.interface'
import { useGetAgentToolsQuery, useGetChatModelsQuery } from '@saaga/shared/store/agents-api.store'

interface UseAgencyEditorDataReturn {
  modelList: LlmModel[]
  isLoadingModels: boolean
  toolList: AgentTool[]
  isLoadingTools: boolean
}

export const useAgencyEditorData = (): UseAgencyEditorDataReturn => {
  const { data: chatModelsData, isLoading: isLoadingModels } = useGetChatModelsQuery()
  const { data: agentToolsData, isLoading: isLoadingTools } = useGetAgentToolsQuery(undefined)

  return {
    modelList: chatModelsData?.modelList ?? [],
    isLoadingModels,
    toolList: agentToolsData?.toolList ?? [],
    isLoadingTools,
  }
}
